import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

//import i18next for translation

import "./i18next";

// import all styles , load theme style first
import "antd/dist/antd.css"; // or 'antd/dist/antd.less'
import "./styles/index.css";

import "./styles/theme.css";
import "./styles/custom-antd.css";

import "./styles/ck-styles.css";
import "./styles/over-write-styles.css";

// load theme
import { loadTheme } from "./components/helper/loadTheme";

//redux setup
import { Provider } from "react-redux";
import { store, persistor } from "./store/store";
import { PersistGate } from "redux-persist/integration/react";

//router setup
import { BrowserRouter as Router } from "react-router-dom";
import { migrateHashUrl } from "./common/migrateHashUrl";

loadTheme();
migrateHashUrl(); // rewrite legacy /#/... URLs before BrowserRouter mounts

ReactDOM.render(
  <Provider store={store}>
    {/* <React.StrictMode> */}
    <PersistGate loading={null} persistor={persistor}>
      <Router>
        <Suspense fallback={<div></div>}>
          <App />
        </Suspense>
      </Router>
    </PersistGate>
    {/* </React.StrictMode> */}
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
